module.exports = "/images/vendor/flag-icon-css/flags/1x1/io.svg?a45231d40c5e618f02372f1b161734d4";